import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import StorageService from "../../util/storage";

const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    }
});

export const fetchNotifications = async (id) => {
    const Notifications = gql`
        query GetNotifications($id: String!) {
            notifications(filters: { organisation: { orgId: { eq: $id } }, show: { eq: true } }, pagination: { limit: 1000 }) {
                data {
                    id
                    attributes {
                        title
                        message
                        createdAt
                    }
                }
            }
        }
    `;

    const response = await client.query({
        query: Notifications,
        variables: { id },
    });
    return response.data.notifications.data;
};
